import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function EditDriver() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        status: "Active",
        documents: [],
        verificationStatus: "",
        documentRemarks: ""
    });

    const [disableBtn, setDisableBtn] = useState(false);
    const [verificationStatus, setVerificationStatus] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.data;

    useEffect(() => {
        if (data) {
            setFormData({
                name: data.name || "",
                email: data.email || "",
                phone: data.phone || "",
                address: data.address || "",
                password: "",
                status: data.status,
                documents: data.documents || [],
                verificationStatus: data.verificationStatus || "",
                documentRemarks: data.documentRemarks || ""
            });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisableBtn(true);

        try {
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
            };

            if ((verificationStatus == 'Rejected' || verificationStatus == "Clarification_Required") && formData.documentRemarks == "") {
                toast.error("Please Fill Document Remarks");
                setDisableBtn(false);
                return;
            }

            const requestData = {
                userId: data._id,
                email: formData.email,
                name: formData.name,
                phone: formData.phone,
                status: formData.status,
                password: formData.password || undefined
            };

            if (verificationStatus && verificationStatus.trim() !== "") {
                requestData.verificationStatus = verificationStatus;
                requestData.documentRemarks = formData.documentRemarks;
            }

            if (!requestData.password) {
                delete requestData.password;
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/admin/edit-driver`,
                requestData,
                { headers }
            );

            setDisableBtn(false);

            if (response.data.statusCode === 200) {
                navigate(-1);
                toast.success(response?.data?.message);
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            setDisableBtn(false);

            console.error(error);
            toast.error("Failed to edit admin user. Please try again.");
        }

    };

    const formatDocType = (str) => {
        if (!str) return "";
        return str
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return (
        <>
            <Layout>
                <ToastContainer />
                <div>
                    <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
                        {/* Header */}
                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-medium">Edit Driver</h2>
                        </div>

                        <div className="mt-10" onSubmit={handleSubmit}>
                            <form action="">
                                {/* User Info */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-sm">Name</label>
                                        <input
                                            type="text"
                                            className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm">Email</label>
                                        <input
                                            type="email"
                                            className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm">Phone</label>
                                        <input
                                            type="text"
                                            className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm">Password</label>
                                        <input
                                            type="password"
                                            className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm">Status</label>
                                        <select
                                            name="status"
                                            value={formData.status}
                                            onChange={handleInputChange}
                                            className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                                        >
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                {/* 🔹 Documents Section */}
                                <div className="mt-10">
                                    <h3 className="text-lg font-medium">Uploaded Documents</h3>
                                    <div className="grid md:grid-cols-3 gap-6 mt-5">
                                        {formData?.documents?.length > 0 ? (
                                            formData?.documents?.map((doc) => (
                                                <div key={doc._id} className="border p-4 rounded shadow-sm">
                                                    <p className="font-medium capitalize">{formatDocType(doc.docType)}</p>

                                                    {doc?.filePath?.toLowerCase().endsWith(".pdf") ? (
                                                        <a
                                                            href={`${process.env.REACT_APP_MEDIA_BASE_URL}/${doc.filePath}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-600 underline mt-2 block"
                                                        >
                                                            View PDF
                                                        </a>
                                                    ) : (
                                                        <a href={`${process.env.REACT_APP_MEDIA_BASE_URL}/${doc.filePath}`}  target="_blank">
                                                        <img
                                                            src={`${process.env.REACT_APP_MEDIA_BASE_URL}/${doc.filePath}`}
                                                            alt={doc.docType}
                                                            className="w-full h-40 object-contain mt-2 border"
                                                        />
                                                        </a>
                                                    )}

                                                </div>
                                            ))
                                        ) : (
                                            <p>No documents uploaded.</p>
                                        )}
                                    </div>
                                </div>

                                {formData?.verificationStatus === "UNDER_REVIEW" && (
                                    <div className="mt-10">
                                        <h3 className="text-lg font-medium">Driver Verification</h3>

                                        <div className="grid grid-cols-2 gap-6 mt-4">
                                            <div>
                                                <label className="text-sm">Verification Status</label>
                                                <select
                                                    name="verificationStatus"
                                                    value={verificationStatus}
                                                    onChange={(e) => setVerificationStatus(e.target.value)}
                                                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                                                >
                                                    <option value="UNDER_REVIEW" >Under Review</option>
                                                    <option value="Approved">Approve</option>
                                                    <option value="Clarification_Required">Clarification Required</option>
                                                    <option value="Rejected">Reject</option>
                                                </select>
                                            </div>

                                            {/* Remarks Textarea */}
                                            <div>
                                                <label className="text-sm">Remarks</label>
                                                <textarea
                                                    name="documentRemarks"
                                                    value={formData.documentRemarks}
                                                    onChange={handleInputChange}
                                                    className="border border-black px-3 w-full mt-1 rounded-sm text-sm h-[80px]"
                                                    placeholder="remarks here..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}


                                <div className="mt-8 text-end">
                                    <button
                                        type="submit"
                                        className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                                        disabled={disableBtn}
                                    >
                                        {disableBtn ? "Editing ..." : "Update"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
